/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Ambienttemperature1Inputs */



/**
* | output |
* | --- |
* | "Ambient temperature" |
*
* @param {Ahu_History_Key_Ambienttemperature1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_ambienttemperature1 = /** @type {((inputs?: Ahu_History_Key_Ambienttemperature1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Ambienttemperature1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Ambient temperature")
	return /** @type {LocalizedString} */ ("Température d'ambiance")
});
export { ahu_history_key_ambienttemperature1 as "ahu_history_key_ambientTemperature" }